
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'ChronicLymphocyticLeukemia_RAI',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Hema/ChronicLymphocyticLeukemia_RAI.vue